import { useEffect, useState } from "react";
import useDataBean from "../../../core/services/dataBean/useDataBean";
import { _ImportRegistry, _ProductInventory, _single } from "../../../core/services/dataBean/EntityCatalog";
import usePaginator from "../../theme/Component/usePaginator";
import useModal, { MODAL_LG, MODAL_SM } from "../../theme/Component/hooks/useModal";
import { MASK_NUMBER } from "../../theme/Component/BasicMultiSelecTable";
import { ListMenu } from "../../theme/Component/ListMenu";
import { toast } from "react-toastify";
import { BasicPage } from "../../theme/Component/BasicPage";
import { BasicTable } from "../../theme/Component/BasicTable";
import { Modal } from "../../theme/Component/Modal";
import { GenericItem } from "../ImportRegistry/GenericItem";
import { NationalizationPhoto } from "../OptionComponents/NationalizationPhoto/NationalizationPhoto";
import { SignList } from "../OptionComponents/SignList/SignList";
import { ImportRegistry } from "../ImportRegistry/ImportRegistry";
import { ModalConfirm } from "../../theme/Component/ModalConfirm";
import { InputDate } from "../../theme/Input/InputDate";
import { PrintJson } from "../../theme/Component/PrintJson";
import { InputMoney } from "../../theme/Input/InputMoney";
import { DownloadFileCard } from "../../theme/Component/DownloadFileCard";
import { BasicButton } from "../../theme/Component/BasicButton";

type filterProps = {
    Year: number;
    State: number;
    ContractNumber: string;
    CompanyName: string;
    ContractObject: string;
}

export const ProductInventory = () => {

    const importRegistry = useDataBean(_ImportRegistry);
    const { bean, setBean, lista, setLista, instance, handleChange, isMissing, isRequired, addRequiredFields, validateForm } = useDataBean(_ProductInventory);
    const paginador = usePaginator();

    const [filter, setFilter] = useState<Partial<filterProps>>({
        Year: _single.getCurrenYear(),
        State: 1,
    })

    const [excelDocument, setExcelDocument] = useState<any>(null);
    const [excelError, setExcelError] = useState<string | null>(null);

    const modalItem = useModal("Items", MODAL_LG);
    const modalEdit = useModal("Editar", MODAL_LG);
    const modalDel = useModal("Eliminar", MODAL_SM);
    const modalImgs = useModal(`Registros fotograficos de ${bean.ContractNumber}`, MODAL_LG);
    const modalSigns = useModal(`Firmas de ${bean.ContractNumber}`, MODAL_LG);
    const modalExcel = useModal(`Reporte de ${bean.ContractNumber}`, MODAL_LG);

    const head = [
        { title: 'No', property: 'IDProductInventory', mask: MASK_NUMBER },
        { title: 'Contrato / Donación', property: 'ContractNumber' },
        { title: 'Objeto de Contrato', property: 'ContractObject', visible: false, Style: { minWidth: "350px" } },
        { title: 'Empresa', property: 'CompanyName' },
        { title: 'Número Manifiesto', property: 'ManifestNumber' },
        { title: 'Fecha Manifiesto INV', property: 'ManifestDateINV' },
        { title: 'Fecha Manifiesto INVM', property: 'ManifestDateINVM' },
        { title: 'Fecha INVM', property: 'DateINVM' },
        { title: 'Depósito NVM', property: 'DepositINVM' },
        { title: 'Peso Bruto', property: 'GrossWeightINVM', mask: MASK_NUMBER },
        { title: 'Observación', property: 'ObservationsINVM' },
        { title: 'Número Transporte', property: 'TransportNumber' },
        { title: 'Fecha de creacion', property: 'Since' },
        { title: 'Nombre Empleado', property: 'EmpleyeeName' },

    ];

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: () => { addItem() } }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => { modalEdit.open() } },
            { titulo: 'Items', icono: 'ri-list-unordered', visible: _single.canEdit(), evento: () => { modalItem.open() } },
            { titulo: 'Registros Fotograficos', icono: 'ri-camera-line', visible: _single.canEdit(), evento: () => { modalImgs.open() } },
            { titulo: 'Descargar Reporte en Excel', icono: 'ri-file-excel-line', visible: _single.canEdit(), evento: () => { getExcel(); } },
            { titulo: 'Firmas', icono: 'ri-quill-pen-line', visible: _single.canEdit(), evento: () => { modalSigns.open() } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: _single.canDelete(), evento: () => { modalDel.open() } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    useEffect(() => {
        addRequiredFields(["IDImportRegistry"])
    }, [])

    useEffect(() => {
        getLista();
    }, [paginador.page])

    const getLista = () => {
        importRegistry.instance.getFormRegistryRender(importRegistry.instance.PRODUCTINVENTORY, paginador.page, 15, _single.cleanMap(filter))
            .then((resp: any) => {
                setLista(resp.List);
                paginador.setPages(resp.NumberOfPages);
            }).catch(err => { toast.error(err) })
    }

    const addItem = () => {
        setBean({
            State: 1,
        });
        modalEdit.open("Agregar Inventario de Mercancias");
    }

    const deleteItem = () => {
        const x = { ...bean, State: 2 };
        editaItem(x);
    };

    const getExcel = () => {
        setExcelDocument(null);
        setExcelError(null);

        importRegistry.instance.getFormatExcelByForm(bean.IDProductInventory, _single.getAccountID(), importRegistry.instance.PRODUCTINVENTORY).then(
            (resp: any) => {
                const document = resp?.Document?.DataBeanProperties
                    ?? resp?.DataBeanProperties?.Document?.DataBeanProperties;

                if (!document?.URL) {
                    setExcelError(document?.ERR ?? "No se genero el archivo Correctamente");
                    modalExcel.open();
                    return;
                }

                setExcelDocument(document);
                modalExcel.open();
            }
        ).catch((err: any) => {
            setExcelError(err?.message ?? String(err ?? "Error desconocido al generar el archivo"));
            modalExcel.open();
        })
    }

    const editaItem = (obj: any) => {
        if (!validateForm()) {
            toast.error("Faltan Campos Obligatorios por diligenciar");
            return;
        }
        instance.updateProductInventory({ ...obj, IDEmployee: _single.getAccountID() }).then(
            (resp: any) => {
                toast.success("Datos Guardados Correctamente");
                modalEdit.close();
                modalDel.close();
                getLista();
            }
        ).catch(err => { toast.error(err) })

    }

    return (
        <BasicPage titulo="Inventario de Mercancias">
            <div className="row ">
                <div className="col-md-4">
                    <label>Contrato</label>
                    <input type="text" className="form-control" value={filter.ContractNumber} onChange={(e) => { setFilter({ ...filter, ContractNumber: e.target.value }) }} />
                </div>
                <div className="col-md-4">
                    <label>Empresa</label>
                    <input type="text" className="form-control" value={filter.CompanyName} onChange={(e) => { setFilter({ ...filter, CompanyName: e.target.value }) }} />
                </div>
                <div className="col-md-4">
                    <label>Objeto del Contrato</label>
                    <input type="text" className="form-control" value={filter.ContractObject} onChange={(e) => { setFilter({ ...filter, ContractObject: e.target.value }) }} />
                </div>
                <div className="col-md-4">
                    <BasicButton eventClick={() => { getLista() }} icon="ri-search-line" children={"Buscar"} useMargin />
                </div>
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={setBean} iconButtons={iconButtonsItem} listButtons={listaBotones()} records={paginador}></BasicTable>
                    {/* <PrintJson json={lista}/> */}
                    <Modal modal={modalEdit.modal} updateModal={modalEdit.setModal} eventModal={() => { editaItem(bean) }}>
                        <div className="row">
                            <div className="col-md-6">
                                <label className={`${isMissing('IDImportRegistry') ? 'has-error' : ''}`}>Contrato / Donacion {isRequired('IDImportRegistry') ? <span className="text-danger">*</span> : ''}</label>
                                <ImportRegistry label=" " editor={true} idSelector={bean.IDImportRegistry} onChange={(e) => { setBean({ ...bean, IDImportRegistry: e.IDImportRegistry }) }} />
                            </div>
                            <div className="col-md-6">
                                <label className={`${isMissing('DepositINVM') ? 'has-error' : ''}`}>Deposito de Inventarios {isRequired('DepositINVM') ? <span className="text-danger">*</span> : ''}</label>
                                <input type="text" className="form-control" value={bean.DepositINVM} onChange={(e) => { setBean({ ...bean, DepositINVM: e.target.value }) }} />
                            </div>

                            <div className="col-md-6">
                                <label className={`${isMissing('DateINVM') ? 'has-error' : ''}`}>Fecha deposito {isRequired('DateINVM') ? <span className="text-danger">*</span> : ''}</label>
                                <InputDate name="DateINVM" value={bean.DateINVM} setDate={(e) => { setBean({ ...bean, DateINVM: e }) }} label=" " />
                            </div>

                            <div className="col-md-6">
                                <label className={`${isMissing('ManifestDateINVM') ? 'has-error' : ''}`}>Fecha de ingreso de la mercancia {isRequired('ManifestDateINVM') ? <span className="text-danger">*</span> : ''}</label>
                                <InputDate name="ManifestDateINVM" value={bean.ManifestDateINVM} setDate={(e) => { setBean({ ...bean, ManifestDateINVM: e }) }} label=" " />
                            </div>

                            <div className="col-md-6">
                                <label className={`${isMissing('TransportNumber') ? 'has-error' : ''}`}>Numero guia de transporte {isRequired('TransportNumber') ? <span className="text-danger">*</span> : ''}</label>
                                <input type="text" className="form-control" value={bean.TransportNumber} onChange={(e) => { setBean({ ...bean, TransportNumber: e.target.value }) }} />
                            </div>

                            <div className="col-md-6">
                                <label className={`${isMissing('ManifestNumber') ? 'has-error' : ''}`}>Numero manifiesto {isRequired('ManifestNumber') ? <span className="text-danger">*</span> : ''}</label>
                                <input type="text" className="form-control" value={bean.ManifestNumber} onChange={(e) => { setBean({ ...bean, ManifestNumber: e.target.value }) }} />
                            </div>

                            <div className="col-md-6">
                                <label className={`${isMissing('ManifestDateINV') ? 'has-error' : ''}`}>Fecha manifiesto {isRequired('ManifestDateINV') ? <span className="text-danger">*</span> : ''}</label>
                                <InputDate name="ManifestDateINV" value={bean.ManifestDateINV} setDate={(e) => { setBean({ ...bean, ManifestDateINV: e }) }} label=" " />
                            </div>

                            <div className="col-md-6">
                                <label className={`${isMissing('GrossWeightINVM') ? 'has-error' : ''}`}>Peso {isRequired('GrossWeightINVM') ? <span className="text-danger">*</span> : ''}</label>
                                <InputMoney _style="decimal" _value={bean.GrossWeightINVM} _label=" " onChange={(e) => { setBean({ ...bean, GrossWeightINVM: e }) }} />
                                {/* <input type="number" className="form-control" value={bean.GrossWeightINVM} onChange={(e) => { setBean({ ...bean, GrossWeightINVM: e.target.value ? parseFloat(e.target.value) : null }) }} /> */}
                            </div>

                            <div className="col-md-12">
                                <label >Observaciones</label>
                                <textarea name="ObservationsINVM" value={bean.ObservationsINVM} onChange={handleChange} className="form-control" />
                            </div>
                        </div>
                    </Modal>

                    <ModalConfirm modal={modalDel.modal} updateModal={modalDel.setModal} eventModal={() => { deleteItem(); }}>
                        Eliminar Inventario de Mercancias {bean.IDProductInventory} - {bean.ContractNumber}
                    </ModalConfirm>

                    <Modal modal={modalItem.modal} updateModal={modalItem.setModal}>
                        <GenericItem typeForm={_ImportRegistry.PRODUCTINVENTORY} formBean={bean} />
                    </Modal>

                    <Modal modal={modalImgs.modal} updateModal={modalImgs.setModal} >
                        <NationalizationPhoto isModal idFormType={bean.IDProductInventory} formType={_ImportRegistry.PRODUCTINVENTORY} />
                    </Modal>

                    <Modal modal={modalSigns.modal} updateModal={modalSigns.setModal} >
                        <SignList isModal idFormType={bean.IDProductInventory} formType={_ImportRegistry.PRODUCTINVENTORY} />
                    </Modal>

                    <Modal modal={modalExcel.modal} updateModal={modalExcel.setModal}>
                        <DownloadFileCard
                            file={excelDocument}
                            error={excelError}
                            fallbackName="Reporte.xlsx"
                            fileTypeLabel="Archivo Excel"
                            buttonLabel="Descargar Excel"
                            icon="ri-file-excel-2-line"
                            iconClassName="text-success"
                            buttonClassName="btn-success"
                        />
                    </Modal>

                </div>
            </div>
        </BasicPage>
    )
}
